export const FORECAST_FILE_TYPE_VALUES = {
  csvItems: 'csv-items',
  csvLandscapeItems: 'csv-landscape-items',
  scopeAttachment: 'scope-attachment',
} as const;

export type ForecastFileType =
  (typeof FORECAST_FILE_TYPE_VALUES)[keyof typeof FORECAST_FILE_TYPE_VALUES];

export const FORECAST_FILE_TYPE_LABELS: Record<ForecastFileType, string> = {
  'csv-items': 'CSV Items',
  'csv-landscape-items': 'CSV Items',
  'scope-attachment': 'Scope Attachment',
};
